import { useIsLoggedIn } from '../../context/AuthMachine';
import { useGetOrderStatusNotificationPreferencesQuery } from './graphql/GetOrderStatusNotificationPreferences.generated';

import type { RequestPolicy } from 'urql';

// ─────────────────────────────────────────────────────────────────────

export const useOrderStatusNotificationPreferences = (params: Params = {}) => {
  const { requestPolicy, pause } = params;

  const isLoggedIn = useIsLoggedIn();

  const [{ data, fetching, error }, refetch] = useGetOrderStatusNotificationPreferencesQuery({
    requestPolicy,
    pause: pause || !isLoggedIn,
  });

  const { getOrderStatusNotificationPreferences: preferences } = data ?? {};

  return {
    refetch,
    isPushSubscribed: preferences?.pushSubscribe ?? true,
    isEmailSubscribed: preferences?.emailSubscribe ?? true,
    error,
    fetching,
  };
};

// ─── Types ───────────────────────────────────────────────────────────

type Params = {
  requestPolicy?: RequestPolicy;
  pause?: boolean;
};
